module.exports = __webpack_public_path__ + "static/media/ktm-17.f3254b60.png";